import { render, staticRenderFns } from "./ManagerDropdown.vue?vue&type=template&id=6cb5353f&scoped=true&"
import script from "./ManagerDropdown.vue?vue&type=script&lang=js&"
export * from "./ManagerDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb5353f",
  null
  
)

export default component.exports